import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";

interface IIncident {
    id: string;
    incidentId: string;
    incident: string;
    incidentDate: string;
    status: number;
    reportedAgainst: string;
}

export const useGetIncident = () => {
    const { user, siteId } = useAuth();
    const [getRecords] = useLazyReadMultipleQuery();
    const [incidents, setIncidents] = useState<IIncident[]>([]);

    useEffect(() => {
        if (user?.contactId) {
            getIncidents();
        }
        // eslint-disable-next-line
    }, [user]);

    const getIncidents = (): Promise<void> => {
        if (!user?.contactId) {
            return Promise.reject('User contact not found.');
        }

        const promises = getRecords({
            userId: user?.contactId || '',
            portalId: siteId || '',
            tableId: "mshied_behaviorincident",
            fieldList: [
                "edtec365_incidentid",
                "mshied_name",
                "mshied_incidentdate",
                "statuscode",
                "edtec365_reportedagainst",
                "mshied_behaviorincidentid"
            ],
            filters: [{
                group: 0, filters: [
                    // Add any necessary filters here
                ]
            }]
        }).unwrap().then((data) => {
            // Process records to extract required fields
            const incidentsRecords = data.records
                .map(record => {
                    console.log("incidentreocrd", record);
                    const reportedAgainst = record["edtec365_reportedagainst"] as string;
                    const reports = JSON.parse(reportedAgainst || '[]') as Array<{ id: string }>;

                    // Check if any section id matches route.sectionmain
                    const isValid = reports.some(section => section.id === user.contactId);

                    if (isValid) {
                        return {
                            incidentId: record["edtec365_incidentid"],
                            incident: record["mshied_name"],
                            incidentDate: record["mshied_incidentdate"],
                            status: record["statuscode"],
                            reportedAgainst: record["edtec365_reportedagainst"],
                            id: record["mshied_behaviorincidentid"]
                        };
                    }

                    return null;
                })
                .filter(record => record !== null) as IIncident[];

            return incidentsRecords;
        }).catch((error) => {
            console.error("Error fetching incidents:", error);
            return [];
        });

        return promises
            .then(results => {
                // Flatten the array of arrays
                const allIncidents = results.flat();
                setIncidents(allIncidents);
            })
            .catch(error => {
                console.error('Error fetching incidents:', error);
            });
    };
console.log("incidents", incidents);
    return { incidents };
};
